import { Component, effect, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FilterGroupStateService } from 'app/core/store/filter/filter-group.state.service';
import { FilterService } from 'app/main/filter-component/filter.service';
//import { is } from 'cypress/types/bluebird';

@Component({
  selector: 'aep-filter',
  imports: [
    MatIcon,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  standalone: true,
})
export class FilterComponent  {
  

  private _filterService = inject(FilterService);
  private _filterGroupState = inject(FilterGroupStateService);
  isVisible = this._filterGroupState.filterVisibilty();
  

  onFilterClick(): void {
    this.isVisible = this._filterGroupState.filterVisibilty();
    this._filterService.toggleFilterVisibility(!this.isVisible);
  }

}
